import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';
import { AdministratorDTO } from 'src/app/shared/models/dtos/responses/administrator-dto/administrator-dto';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Image Upload Molecule
 */
export class ImageUploadComponent implements OnInit {
  @Input() fileUploadLabel!: string[];
  @Input() fileUploadAlt!: string[];
  @Input() icon = 'person';
  admin?: AdministratorDTO;
  @Input() control: AbstractControl | null | undefined;
  imgUrl?: string;
  @Output() imgUrlChange = new EventEmitter<string>();
  private subsink = new Subscription();

  /**
   * set up file url if avaiable from form control
   */
  ngOnInit() {
    this.imgUrl = '';
    this.subsink.add(
      this.authenticatedUserService.admin$.subscribe((info) => {
        this.admin = info;
        this.imgUrl = info?.picture;
      })
    );

    this.loadProfilePicture();
  }

  /**
   * Constructor to import translation service
   */
  constructor(
    private readonly authenticatedUserService: AuthenticatedUserService,
    private readonly dialogService: DialogService
  ) {}

  /**
   * Admin profile picture if available
   * @return {string | false}
   */
  hasProfilePicture() {
    return this.authenticatedUserService.admin?.picture
      ? this.authenticatedUserService.admin.picture
      : undefined;
  }

  /**
   * Opens modal
   */
  openUpdateImageModal() {
    this.dialogService.openUpdateImage(
      { picture: this.hasProfilePicture() },
      (res) => {
        this.imgUrl = res;
        this.imgUrlChange.emit(this.imgUrl!);
      }
    );
  }

  /**
   * cleans up resources
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  /**
   * Loads right image
   */
  loadProfilePicture() {
    if (this.hasProfilePicture()) {
      this.imgUrl = this.hasProfilePicture();
    }
  }
}
